var _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 10,
    viewBox: "0 0 63 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7166_12510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.58841 9.647C2.34802 9.77031 2.07525 9.55421 2.12383 9.27833L2.64072 6.33269L0.446742 4.24271C0.241855 4.04716 0.348347 3.6897 0.622983 3.65109L3.67325 3.21765L5.03336 0.522977C5.15604 0.280101 5.48797 0.280101 5.61065 0.522977L6.97076 3.21765L10.021 3.65109C10.2957 3.6897 10.4022 4.04716 10.1966 4.24271L8.00329 6.33269L8.52018 9.27833C8.56875 9.55421 8.29598 9.77031 8.0556 9.647L5.32107 8.24206L2.58841 9.647Z",
    fill: "#F4B400"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7166_12510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6665 9.647C15.4261 9.77031 15.1534 9.55421 15.202 9.27833L15.7188 6.33269L13.5249 4.24271C13.32 4.04716 13.4265 3.6897 13.7011 3.65109L16.7514 3.21765L18.1115 0.522977C18.2342 0.280101 18.5661 0.280101 18.6888 0.522977L20.0489 3.21765L23.0991 3.65109C23.3738 3.6897 23.4803 4.04716 23.2748 4.24271L21.0814 6.33269L21.5983 9.27833C21.6469 9.55421 21.3741 9.77031 21.1337 9.647L18.3992 8.24206L15.6665 9.647Z",
    fill: "#F4B400"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_7166_12510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7447 9.647C28.5043 9.77031 28.2315 9.55421 28.2801 9.27833L28.797 6.33269L26.603 4.24271C26.3981 4.04716 26.5046 3.6897 26.7792 3.65109L29.8295 3.21765L31.1896 0.522977C31.3123 0.280101 31.6442 0.280101 31.7669 0.522977L33.127 3.21765L36.1773 3.65109C36.4519 3.6897 36.5584 4.04716 36.3529 4.24271L34.1595 6.33269L34.6764 9.27833C34.725 9.55421 34.4522 9.77031 34.2118 9.647L31.4773 8.24206L28.7447 9.647Z",
    fill: "#F4B400"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_7166_12510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8223 9.647C41.5819 9.77031 41.3091 9.55421 41.3577 9.27833L41.8746 6.33269L39.6806 4.24271C39.4757 4.04716 39.5822 3.6897 39.8569 3.65109L42.9071 3.21765L44.2672 0.522977C44.3899 0.280101 44.7219 0.280101 44.8445 0.522977L46.2046 3.21765L49.2549 3.65109C49.5295 3.6897 49.636 4.04716 49.4305 4.24271L47.2372 6.33269L47.7541 9.27833C47.8026 9.55421 47.5299 9.77031 47.2895 9.647L44.555 8.24206L41.8223 9.647Z",
    fill: "#F4B400"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7166_12510",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 0,
    width: 11,
    height: 10
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_7166_12510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9004 9.647C54.66 9.77031 54.3873 9.55421 54.4358 9.27833L54.9527 6.33269L52.7588 4.24271C52.5539 4.04716 52.6604 3.6897 52.935 3.65109L55.9853 3.21765L57.3454 0.522977C57.4681 0.280101 57.8 0.280101 57.9227 0.522977L59.2828 3.21765L62.333 3.65109C62.6077 3.6897 62.7142 4.04716 62.5087 4.24271L60.3153 6.33269L60.8322 9.27833C60.8808 9.55421 60.608 9.77031 60.3676 9.647L57.6331 8.24206L54.9004 9.647Z",
    fill: "#EAEAEA"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7166_12510)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.1929,
    y: 0.34082,
    width: 10.4217,
    height: 9.55318,
    fill: "#F4B400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7166_12510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.96413,
    height: 9.96413,
    fill: "white",
    transform: "translate(0.338379 0.0302734)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7166_12510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.96413,
    height: 9.96413,
    fill: "white",
    transform: "translate(13.4165 0.0302734)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_7166_12510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.96413,
    height: 9.96413,
    fill: "white",
    transform: "translate(26.4946 0.0302734)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_7166_12510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.96413,
    height: 9.96413,
    fill: "white",
    transform: "translate(39.5723 0.0302734)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_7166_12510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.96413,
    height: 9.96413,
    fill: "white",
    transform: "translate(52.6504 0.0302734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.f385c932d13099dfbc4e70a2371576f2.svg";
export { ForwardRef as ReactComponent };